export default __webpack_public_path__ + "static/media/slider4.1fcf0e0a.jpg";